import React from "react";
import Filters from "../components/form/Filters";

const PredictionFilters = (props) => <Filters {...props} />;

export default PredictionFilters;
